<div class="container">
  <h2>Om tjänsten</h2>
  <p>
    <span [style.font-weight]="'bold'">Bildsamtycke</span> är en tjänst som samlar samtyckesavtal för
    både privatpersoner och företag/organisationer.
  </p>
  <p>
    <span [style.font-weight]="'bold'">Som privatperson</span> blir Bildsamtycke det enkla sättet
    till överblick av de samtyckesavtal man godkänt. De kan också administreras
    , återkallas och ändras om avtalen uppdateras.
  </p>
  <p>
    <span [style.font-weight]="'bold'">För fotografer</span> finns en utökad tjänst med möjlighet att skapa
    samtyckesavtal, be om signeringar genom BankId samt få en fullständig koll
    på de avtal som finns, hur länge de gäller och vilka bilder de berör
  </p>
  <p>
    <span [style.font-weight]="'bold'">Är du fotograf</span> och vill prova vår utökade tjänst samt veta mer
    om betalningsupplägg ber vi dig <span><a href="mailto:info@bildsamtycke.se">kontakta oss.</a></span>
  </p>
  <p>
    <span [style.font-weight]="'bold'">Vår tjänst är så trygg den kan bli</span> för alla parter i ett avtal.
    Vi kräver auktorisering av alla fotografer som använder tjänsten. Tjänsten
    kan inte användas inkognito och alla överträdelser av Svensk lag leder till
    evig uteslutning.
  </p>
</div>
